/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'
import {
  Button,
  BlockingLoader,
  Container,
  Icon,
  ListContainer,
  TextTitle,
  TextBody,
  Tools
} from '@pdrj/pmi-iqos-ds-react'
import {
  Assets,
  LayoutContainer,
  LazyImage,
  htmlTranslation,
  Routes,
  goToRoute
} from '@pdrj/pmi-iqos-shared-react'
import SpotsUsageBadge from './spots-usage-badge'
import SpotsBusinessBadge from './spots-business-badge'
import SpotsMapsButton from './spots-maps-button'
import SpotsStoreLink from './spots-store-link'
import SpotServiceTypeBadge from './spots-service-type-badge'
const SpotsVenueDetail = ({
  translations,
  usageTypes,
  businessTypes,
  spot,
  backToList,
  filters,
  hasErrors
}) => {
  const [isComingFromMap, setIsComingFromMap] = useState(false)
  const usageBadge = <SpotsUsageBadge spot={spot} usageTypes={usageTypes} />

  const serviceTypeBadge = (
    <SpotServiceTypeBadge
      tags={spot.serviceType}
      serviceTypes={filters.filter(i => i.type === 'serviceType')}
    />
  )

  useEffect(() => {
    const pageUrl = window.location.href

    if (pageUrl.includes('#map')) {
      setIsComingFromMap(true)
    }
  }, [])

  const handleGoBack = () => {
    isComingFromMap ? goToRoute({ mainPath: Routes.spotPage }) : backToList()
  }

  return (spot && spot.spotId) || hasErrors ? (
    <LayoutContainer fullWidth xMainLayout={Tools.isDesktop()} yMainLayout>
      <Container pl={['8', '0']}>
        <Button
          icon={Icon.images.arrowLeft}
          iconPosition={Button.iconPositions.left}
          onClickHandler={handleGoBack}
          text={
            isComingFromMap
              ? translations.tk_returnToMap
              : translations.tk_returnToList
          }
          variant={Button.variants.tertiary}
          data-testing="SpotsVenueDetail_Button_Back"
        />
      </Container>
      {hasErrors ? (
        <TextBody {...htmlTranslation(translations, 'tk_noSpotFound')} />
      ) : (
        <Container
          layout={Container.layouts.mid}
          display={Container.displays.flex}
          flexDirection={[
            Container.flexDirections.column,
            Container.flexDirections.row
          ]}>
          <Container
            width={['full', '6/12']}
            position={Container.positions.relative}>
            <Container position={Container.positions.absolute} t="0" l="0">
              <SpotsBusinessBadge spot={spot} businessTypes={businessTypes} />
            </Container>
            <LazyImage
              src={spot.spotImage || Assets.urls.imageSpotDefault}
              width="full"
            />
          </Container>
          <Container
            width={['full', '6/12']}
            px={['8', '0']}
            pl={['8', '32']}
            pt={['6', '0']}>
            <Container>
              <SpotsBusinessBadge
                spot={spot}
                businessTypes={businessTypes}
                filters={filters}
              />
            </Container>
            <Container py="4">
              <TextTitle
                heading={TextTitle.headings.h6}
                data-testing={'SpotsVenueDetail_TextTitle_SpotName'}>
                {spot.spotName}
              </TextTitle>
            </Container>
            <TextBody>
              {spot.prefecture} {spot.address}
            </TextBody>
            <TextBody>
              {translations.tk_telephone} {spot.telephone}
            </TextBody>
            <Container pt="8" display={Container.displays.flex}>
              <ListContainer xBetween="8" yBetween="8" columns={[1, null]}>
                <SpotsMapsButton spot={spot} translations={translations} />
                <SpotsStoreLink
                  spot={spot}
                  translations={translations}
                  data-testing-prefix="SpotsVenueDetail"
                />
              </ListContainer>
            </Container>
            <Container py="4">
              <TextBody>{spot.description}</TextBody>
            </Container>
            <Container display={Container.displays.flex} pt="2">
              <ListContainer
                xBetween="2"
                yBetween="2"
                columns={[1, null]}
                truncate={true}>
                {usageBadge}
                {serviceTypeBadge}
              </ListContainer>
            </Container>
          </Container>
        </Container>
      )}
    </LayoutContainer>
  ) : (
    <BlockingLoader loading />
  )
}

export default SpotsVenueDetail
